<template>
  <div>
    <Hero :image="'banner-home/1.jpg'" height="300px"  title="<strong>Uoops</strong>"/>

    <div class="row pb-5 mt-5">
      <div class="col-12 col-lg-8 mx-auto mt-n4">
        <div class="bg-white shadow-sm p-5">
          <div class="d-flex align-items-center justify-content-center">

            <alert-circle-outline-icon style="font-size:120px;" class="text-blue-ml"/>

            <div class="mt-3" v-html="template"></div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hero from "@/components/media/Hero.vue";
import AlertCircleOutlineIcon from "vue-material-design-icons/AlertCircleOutline.vue";

export default {
  name: "EliminatedByQuestions",

  computed: {
    template(){
      return this.$route.params.template
    }
  },

  components: {
    Hero,
    AlertCircleOutlineIcon
  }
};
</script>

<style lang="scss"></style>